import { render, staticRenderFns } from "./AllRatingsAdmin.vue?vue&type=template&id=46d8cb7d&scoped=true"
import script from "./AllRatingsAdmin.vue?vue&type=script&lang=js"
export * from "./AllRatingsAdmin.vue?vue&type=script&lang=js"
import style0 from "./AllRatingsAdmin.vue?vue&type=style&index=0&id=46d8cb7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d8cb7d",
  null
  
)

export default component.exports